import { useLocation, useNavigate } from "react-router-dom";
import { ReactNode, useState } from "react";
import { MdHomeFilled, MdOutlinePrivacyTip } from "react-icons/md";
import { RiQuestionAnswerFill } from "react-icons/ri";
import { getId } from "../../api/axiosInstanceApi";
import { UserDetailsObjectProps } from "./Layout";
import UserProfileIcon from "./userProfileIcon";
import { Popover, PopoverContent, PopoverHandler } from "@material-tailwind/react";
import { AiOutlineExclamationCircle } from "react-icons/ai";
import { APP_NAME } from "../../utils/appConstant";

export interface SideBarIconProps {
  icon: ReactNode;
  text: string;
  to: string;
  response?: string;
  conversation_id?: string;
}

export const SideBarIcon = ({ icon, text, to }: SideBarIconProps) => {
  const location = useLocation();
  const navigate = useNavigate();

  // Use includes to check for active state
  const isActive =
    (to === "/" && location.pathname === "/") || // Ensure exact match for "/"
    (to === "/interaction" && location.pathname.includes("/interaction/")) ||
    (to !== "/" && location.pathname === to); // Match child routes

  const handleClick = async () => {
    if (to === "/interaction") {
      try {
        const idResponse = await getId();
        const id = idResponse.data;

        navigate(`/interaction/${id.Id}`, {
          state: { from: "new" }
        });
      } catch (error) {
        console.error("Failed to fetch ID and navigate", error);
      }
    } else {
      navigate(to);
    }
  };

  return (
    <button onClick={handleClick} className={`sidebar-icon group ${isActive ? "activeSideNav" : ""}`} disabled={isActive}>
      {icon}
      <span className="sidebar-tooltip group-hover:scale-100">{text}</span>
    </button>
  );
};
const SideBar = ({ userDetails }: UserDetailsObjectProps) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  return (
    <div
      className=" sticky top-16 left-0 w-16 flex flex-col justify-between
            bg-slate-800 shadow-lg sidebar-height z-10"
    >
      <div>
        <SideBarIcon icon={<MdHomeFilled size="28" />} text={"Workbench"} to="/" />
        <SideBarIcon icon={<RiQuestionAnswerFill size="28" />} text={"Interaction"} to="/interaction" />
        <div className="absolute  bottom-0 m-2">
          <div className=" text-sky-400    relative flex items-center justify-center h-12 w-12 mt-2 mb-2 mx-auto">
            <Popover open={isPopoverOpen} handler={() => setIsPopoverOpen(!isPopoverOpen)} placement="bottom-end">
              <PopoverHandler>
                <div className="cursor-pointer ">
                  {/* <IoMdInformationCircleOutline size={28} /> */}
                  <AiOutlineExclamationCircle size={28} />
                </div>
              </PopoverHandler>
              <PopoverContent className="m-1  z-50 card_bg_color w-72 h-auto rounded-lg shadow-lg">
                <strong className="inline-block card_text_color text-lg">What’s New</strong>
                <ul className="mt-1 ml-2 list-disc text-sm card_text_color space-y-2">
                  <li>
                    <span className="font-semibold">User Role Selection:</span> Users are now able to select their specific role prior to
                    commencing any interaction with {APP_NAME}, thereby enabling more tailored responses.
                  </li>
                  <li>
                    <span className="font-semibold">Improved Responses:</span> {APP_NAME}'s content referencing has been enhanced, resulting in
                    improved citation accuracy and more relevant, high-quality responses.
                  </li>
                  <li>
                    <span className="font-semibold">New Podcast Content:</span> Episodes from Software People Stories have been incorporated
                    into our knowledge base to facilitate richer, experience-based responses.
                  </li>
                  <li>
                    <span className="font-semibold">Bug Fixes:</span> Numerous internal improvements and fixes have been implemented to
                    ensure a smoother user experience.
                  </li>
                </ul>
                <div className="w-full h-px bg-gray-100 shadow-2xl opacity-50 duration-200 ease-in-out mt-3 mb-2" />
                <span className="inline-block card_text_color text-xs">
                  <strong>Important:</strong>&nbsp;{APP_NAME} is currently in Beta. There may be partial or sometimes inaccurate results. Please
                  use your discretion.
                </span>
              </PopoverContent>
            </Popover>
          </div>
          <div className="sm:hidden relative flex items-center justify-center h-12 w-12 mt-2 mb-2 mx-auto">
            <UserProfileIcon userDetails={userDetails}></UserProfileIcon>
          </div>
          <SideBarIcon icon={<MdOutlinePrivacyTip size="28" />} text={"Terms Of Use and Privacy Policy"} to="/terms&privacy-policy" />
        </div>
      </div>
    </div>
  );
};

export default SideBar;
